module.exports = __webpack_public_path__ + "img/1546544600.f83c790a.jpg";